<template>
    <Transition name="error-fade">
        <div v-if="errors.length" class="text-left">
            <span class="p-error">{{ errors[0] }}</span>
        </div>
    </Transition>
</template>

<script>
export default {
    name: 'InputError',
    props: {
        errors: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
/* azért margin-al animálok mert így nem ugrik az animáció és nem látszik mikor kiszedi a DOM-ból az elemet
B verzió, hogy position absolute-al toljátok oda, de ezt már rátok bízom */
.error-fade {
    &-enter,
    &-leave-to {
        @apply opacity-0;
        @apply -mt-5;
    }

    &-enter-active,
    &-leave-active {
        @apply transition-all;
    }

    &-enter-to,
    &-leave {
        @apply opacity-100;
        @apply mt-0;
    }
}
</style>
